import { render } from "./qualification.vue?vue&type=template&id=66cf7151&ts=true"
import script from "./qualification.vue?vue&type=script&lang=ts"
export * from "./qualification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__